// Captures the Chromium `beforeinstallprompt` event so the app can trigger the
// native PWA install dialog on demand, instead of relying on Chrome's own
// (heavily throttled, non-deterministic) mini-infobar.
//
// The event can fire before React mounts, so the listener is attached at module
// load time and the deferred event is kept in module scope. Import this module
// early in index.js.

let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((cb) => cb());

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  notify();
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  notify();
});

// The captured event, or null if Chrome hasn't offered installation.
export const getDeferredPrompt = () => deferredPrompt;

// Subscribe to availability changes. Fires immediately if already captured.
// Returns an unsubscribe function.
export const subscribe = (cb) => {
  listeners.add(cb);
  if (deferredPrompt) cb();
  return () => listeners.delete(cb);
};

// Opens the native install dialog. Returns the user's choice outcome
// ('accepted' | 'dismissed'), or null if no prompt is available.
export const promptInstall = async () => {
  const event = deferredPrompt;
  if (!event) return null;
  deferredPrompt = null;
  notify();
  event.prompt();
  const { outcome } = await event.userChoice;
  return outcome;
};
